var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useState } from 'react';
export function useInput(props) {
    var _a, _b, _c;
    var _d = useState(null), value = _d[0], setValue = _d[1];
    return __assign(__assign({}, props), { value: (_b = (_a = props.value) !== null && _a !== void 0 ? _a : value) !== null && _b !== void 0 ? _b : '', onChange: (_c = props.onChange) !== null && _c !== void 0 ? _c : setValue });
}
//# sourceMappingURL=useInput.js.map